export const allowedAtlassianFields: {
  Query: string[];
  Mutation: string[];
  Subscription: string[];
} = {
  Query: ['echo'],
  Mutation: [],
  Subscription: [],
};
